import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { filter, switchMap, take, tap, withLatestFrom } from 'rxjs/operators';

import { getRouterQueryParamsModule, getRouterQueryParamsType } from '@app/app.reducer';
import { PlatformService } from '@core/services/platform.service';
import * as FormActions from '@shared/form/store/form.actions';

import { UploadContainerComponent } from '../upload/upload.container';
import { AssociationModule } from '@shared';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadModalContainerComponent implements OnDestroy {
  subscription: Subscription;

  constructor(
    private store: Store<{}>,
    private router: Router,
    private platformService: PlatformService,
  ) {
    this.subscription = this.router.events
      .pipe(
        filter((event: Event) => event instanceof NavigationEnd),
        switchMap(() => this.store.select(getRouterQueryParamsType)),
        withLatestFrom(
          this.platformService.isMobileView$,
          this.store.select(getRouterQueryParamsModule),
        ),
        take(1),
        tap(([type, isMobileView, module]: [string, boolean, string]) => {
          const header = isMobileView ? `Upload ${type}` : 'Upload';
          this.store.dispatch(
            FormActions.formOpen({
              formState: {
                component: UploadContainerComponent,
                data: {
                  header,
                  panelClass: 'large-size-modal',
                  closeWithoutAdditionalModal: module === AssociationModule.NOTE,
                },
              },
            }),
          );
        }),
      )
      .subscribe();
  }

  ngOnDestroy() {
    return !!this.subscription && this.subscription.unsubscribe();
  }
}
